// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { Record, RepeatableItemValue } from '@fulcrumapp/fulcrum-core';
import cx from 'classnames';
import EditorLevel from '../models/editor-level';
import {
  CloseIcon, AddIcon, EditIcon, SaveIcon,
} from '../../icons';

export default class HeaderView extends React.Component {
  static propTypes = {
    levelDepth: PropTypes.number,
    className: PropTypes.string,
    loading: PropTypes.bool.isRequired,
    previewMode: PropTypes.bool.isRequired,
    editing: PropTypes.bool.isRequired,
    level: PropTypes.instanceOf(EditorLevel).isRequired,
    topBorder: PropTypes.bool.isRequired,
    showCloseButton: PropTypes.bool.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onEditClick: PropTypes.func.isRequired,
    onSaveClick: PropTypes.func.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    record: PropTypes.instanceOf(Record).isRequired,
    viewOnlyMode: PropTypes.bool.isRequired,
  };

  render() {
    const { styles } = HeaderView;

    let classes = null;

    if (this.props.previewMode) {
      classes = css(styles.containerPreviewing);
    } else {
      classes = css(this.props.editing ? styles.containerEditing : styles.container);
    }

    return (
      <div className={cx(this.props.className, classes)}>
        {this.renderTopBar()}
        {this.props.showCloseButton && this.renderCloseButton()}
        {this.renderTitle()}
        {this.renderAddButton()}
        {this.renderEditButton()}
        {this.renderSaveButton()}
      </div>
    );
  }

  renderTopBar() {
    const { styles } = HeaderView;

    const classNames = [];

    if (this.props.topBorder) {
      if (this.props.previewMode) {
        classNames.push(styles.topBorderPreviewing);
      } else {
        classNames.push(this.props.editing ? styles.topBorderEditing : styles.topBorder);
      }
    }

    return (
      <div className={css(classNames, styles.outer)}>
        <div className={css(styles.inner, this.props.loading && styles.loading)} />
      </div>
    );
  }

  renderTitle() {
    const { styles } = HeaderView;

    return (
      <div
        className={css(styles.title)}
        title={this.title}
      >
        {this.title}
        {this.renderEditingEmbellishment()}
      </div>
    );
  }

  renderEditButton() {
    if (this.props.editing || this.props.viewOnlyMode) {
      return null;
    }

    const { styles } = HeaderView;

    return (
      <div
        className={css(styles.editButton)}
        title="Edit"
        onClick={this.props.onEditClick}
      >
        <EditIcon style={{ fill: '#eb1300' }} />
      </div>
    );
  }

  renderSaveButton() {
    // if (!this.props.editing || this.props.level.isSectionLevel) {
    //   return null;
    // }

    const { styles } = HeaderView;
    const { levelDepth } = this.props;

    return (
      <div
        className={css(styles.saveButton)}
        title="Save"
        onClick={this.props.onSaveClick}
        data-testid={`save-button-${levelDepth}`}
      >
        <SaveIcon style={{ fill: '#7db400' }} />
      </div>
    );
  }

  renderAddButton() {
    if (this.props.level.isRepeatableIndexLevel && this.props.editing) {
      const { styles } = HeaderView;

      return (
        <div
          className={css(styles.addButton)}
          title="Menu"
          onClick={this.props.onAddClick}
        >
          <AddIcon style={{ fill: '#f00' }} />
        </div>
      );
    }

    return null;
  }

  renderCloseButton() {
    const { styles } = HeaderView;

    return (
      <div
        className={css(styles.closeButton)}
        title="Close"
        onClick={this.props.onCloseClick}
      >
        <CloseIcon style={{ fill: '#eb1300' }} />
      </div>
    );
  }

  renderEditingEmbellishment() {
    const { styles } = HeaderView;

    if (this.props.previewMode) {
      return <span className={css(styles.editing)}>(previewing)</span>;
    }

    if (this.props.editing) {
      return <span className={css(styles.editing)}>(editing)</span>;
    }

    return null;
  }

  handleMenuClick = (event) => {
    // nothing
  };

  get title() {
    if (this.props.level.feature instanceof RepeatableItemValue) {
      return this.props.level.feature.element.label;
    }

    return this.props.level.record.form.name;
  }
}

const styles = cssInJS({
  container: {
    position: 'relative',
    backgroundColor: '#fff',
    transition: 'background-color 300ms ease',
    borderBottom: '1px solid #d9d9d9',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
  },

  containerPreviewing: {
    position: 'relative',
    backgroundColor: '#FFF9C4',
    transition: 'background-color 300ms ease',
    borderBottom: '1px solid #d9d9d9',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
  },

  containerEditing: {
    position: 'relative',
    backgroundColor: '#c7eaff',
    transition: 'background-color 300ms ease',
    borderBottom: '1px solid #d9d9d9',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
  },

  editing: {
    fontStyle: 'italic',
    fontWeight: 'normal',
    color: '#777',
    marginLeft: 6,
    fontSize: 13,
    position: 'relative',
    top: -2,
  },

  topBorder: {
    position: 'absolute',
    alignSelf: 'flex-start',
    width: '100%',
    backgroundColor: 'red',
    height: 0,
  },

  topBorderEditing: {
    position: 'absolute',
    alignSelf: 'flex-start',
    width: '100%',
    height: 0,
    backgroundColor: '#18a3f7',
  },

  topBorderPreviewing: {
    position: 'absolute',
    alignSelf: 'flex-start',
    width: '100%',
    height: 0,
    backgroundColor: '#FFD600',
  },

  title: {
    paddingLeft: 16,
    paddingRight: 16,
    fontWeight: 400,
    fontSize: '1.25rem',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flex: '1 1 auto',
  },

  editButton: {
    width: 48,
    minWidth: 48,
    height: 48,
    borderLeft: '1px solid #d9d9d9',
    borderBottom: '1px solid #d9d9d9',
    marginRight: 0,
    cursor: 'pointer',
    backgroundColor: '#fff',
    padding: 8,
    textAlign: 'center',
    fill: '#eb1300',
    flex: '0 1 auto',
  },

  saveButton: {
    width: 48,
    minWidth: 48,
    height: 48,
    borderLeft: '1px solid #d9d9d9',
    borderBottom: '1px solid #d9d9d9',
    marginRight: 0,
    cursor: 'pointer',
    backgroundColor: '#fff',
    padding: 8,
    textAlign: 'center',
    fill: '#7db400',
    flex: '0 1 auto',
  },

  addButton: {
    width: 48,
    minWidth: 48,
    height: 48,
    borderLeft: '1px solid #d9d9d9',
    borderRight: '1px solid #d9d9d9',
    borderBottom: '1px solid #d9d9d9',
    marginRight: 10,
    cursor: 'pointer',
    backgroundColor: '#fff',
    padding: 8,
    textAlign: 'center',
    fill: '#eb1300',
    flex: '0 1 auto',
  },

  closeButton: {
    width: 36,
    minWidth: 36,
    height: 48,
    borderRight: '1px solid #d9d9d9',
    borderBottom: '1px solid #d9d9d9',
    cursor: 'pointer',
    backgroundColor: '#fff',
    padding: 8,
    paddingTop: 14,
    textAlign: 'center',
    fill: '#eb1300',
    flex: '0 1 auto',
  },

  inset: {
    boxShadow: 'inset 0px 0px 8px 0px rgba(0,0,0,0.3)',
  },

  inner: {
    width: 0,
    visibility: 'hidden',
  },

  loading: {
    position: 'relative',
    top: 0,
    zIndex: 5,
    backgroundColor: '#f00',
    height: 8,
    visibility: 'visible',
    width: '100%',
    transition: 'width 500ms ease-out',
  },
});

HeaderView.styles = styles;
